import { render, staticRenderFns } from "./downChoice.vue?vue&type=template&id=1d6bef94&scoped=true&"
import script from "./downChoice.vue?vue&type=script&lang=js&"
export * from "./downChoice.vue?vue&type=script&lang=js&"
import style0 from "./downChoice.vue?vue&type=style&index=0&id=1d6bef94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6bef94",
  null
  
)

export default component.exports